export const journeys = [
  {
    slug: "miami",
    status: "upcoming",
    city: "Miami",
    region: "Florida, USA",
    dateLabel: "JAN 24–27",
    category: "Culinary Experience",
    title: "Coastal Fire & Latin Heat",
    excerpt:
      "Four days of open-fire cooking, Cuban bakeries and a rooftop feast above Biscayne Bay.",
    description:
      "Eddie lands on the coast for a long weekend of open-fire cooking, market mornings and a rooftop dinner overlooking Biscayne Bay. Expect smoke, citrus and a table that runs long past sunset.",
    storyTitle: "Where the Atlantic Meets the Grill",
    story:
      "Miami taught Eddie that fire and the sea can share a plate. Between Little Havana's bakeries and the late-night grills of Wynwood, the city cooks with rhythm — loud, generous and impossible to hurry. This is the story of a weekend spent chasing smoke across the causeway.",
    image:
      "https://readdy.ai/api/search-image?query=Miami%20Art%20Deco%20coastline%20at%20golden%20hour%20with%20palm%20trees%20and%20warm%20cinematic%20light%2C%20documentary%20editorial%20travel%20photography%2C%20muted%20warm%20palette%2C%2035mm%20film%20grain%2C%20atmospheric%20haze&width=1000&height=1250&seq=journey-miami-coast&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=open%20fire%20grill%20on%20a%20beach%20at%20dusk%20with%20smoke%20and%20warm%20ember%20glow%2C%20documentary%20editorial%20photography%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-miami-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cuban%20bakery%20counter%20with%20fresh%20pastries%20and%20warm%20morning%20light%20pouring%20in%2C%20documentary%20editorial%20photography%2C%20warm%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-miami-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=rooftop%20long%20dinner%20table%20overlooking%20a%20city%20bay%20at%20sunset%2C%20documentary%20editorial%20photography%2C%20warm%20golden%20light%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-miami-g3&orientation=landscape",
    ],
    highlights: [
      "An open-fire masterclass on the sand",
      "Sunrise market walk through Little Havana",
      "A 40-seat rooftop feast above Biscayne Bay",
      "A conversation with local fishermen and growers",
    ],
  },
  {
    slug: "new-york",
    status: "upcoming",
    city: "New York",
    region: "New York, USA",
    dateLabel: "FEB 08–11",
    category: "Chef Experience",
    title: "The City That Never Stops Cooking",
    excerpt:
      "A chef's-eye tour of borough kitchens, midnight dumplings and a private tasting menu.",
    description:
      "Four days across the boroughs — from Brooklyn smokehouses to a private tasting menu in a Manhattan loft. Eddie cooks, listens and trades stories with the people who feed the city every night.",
    storyTitle: "Borough by Borough, Plate by Plate",
    story:
      "New York is not one kitchen, it is thousands arguing with each other in the best possible way. Eddie spent the week moving between them — tasting, talking, and learning how the city reinvents itself one menu at a time.",
    image:
      "https://readdy.ai/api/search-image?query=New%20York%20City%20skyline%20at%20dusk%20seen%20from%20a%20rooftop%20with%20warm%20city%20lights%2C%20cinematic%20editorial%20travel%20photography%2C%20moody%20warm%20tones%2C%2035mm%20film%20grain%2C%20atmospheric%20depth&width=1000&height=1250&seq=journey-nyc-rooftop&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=steam%20rising%20over%20a%20Brooklyn%20smokehouse%20counter%20at%20night%2C%20documentary%20editorial%20photography%2C%20warm%20amber%20light%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-nyc-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=midnight%20street%20food%20stall%20with%20glowing%20lanterns%20in%20a%20busy%20city%2C%20documentary%20editorial%20photography%2C%20warm%20light%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-nyc-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=private%20loft%20tasting%20menu%20table%20set%20with%20candlelight%20and%20wine%2C%20documentary%20editorial%20photography%2C%20warm%20tones%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-nyc-g3&orientation=landscape",
    ],
    highlights: [
      "Borough-by-borough kitchen crawl",
      "A private tasting menu in a Manhattan loft",
      "Midnight dumplings and street-food stories",
      "A roundtable with the city's rising chefs",
    ],
  },
  {
    slug: "denver",
    status: "upcoming",
    city: "Denver",
    region: "Colorado, USA",
    dateLabel: "MAR 18–21",
    category: "Locavore Journey",
    title: "High Country, Local Table",
    excerpt:
      "Mountain air, ranch-to-table dinners and the Locavore story told at altitude.",
    description:
      "Eddie heads for the high country to cook with ranchers, brewers and growers who feed the Rockies. Three days of mountain markets, long tables and the Locavore conversation at altitude.",
    storyTitle: "Cooking at the Edge of the Rockies",
    story:
      "At altitude everything changes — water boils cooler, seasons arrive sharper, and the food tastes of the place it came from. Denver reminded Eddie why locavore is not a trend but a geography.",
    image:
      "https://readdy.ai/api/search-image?query=Rocky%20Mountain%20foothills%20at%20sunrise%20with%20an%20alpine%20farm-to-table%20setting%2C%20cinematic%20editorial%20travel%20photography%2C%20warm%20earthy%20palette%2C%2035mm%20film%20grain%2C%20soft%20haze&width=1000&height=1250&seq=journey-denver-rockies&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=ranch%20cattle%20grazing%20on%20a%20high%20country%20plain%20at%20golden%20hour%2C%20documentary%20editorial%20photography%2C%20warm%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-denver-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=long%20outdoor%20autumn%20table%20under%20string%20lights%20in%20the%20mountains%2C%20documentary%20editorial%20photography%2C%20warm%20light%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-denver-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=craft%20brewery%20interior%20with%20warm%20wood%20and%20glowing%20taps%2C%20documentary%20editorial%20photography%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-denver-g3&orientation=landscape",
    ],
    highlights: [
      "Ranch-to-table dinner in the foothills",
      "A mountain market morning at first light",
      "Home-brew and fermentation sessions",
      "The Locavore conversation, live at altitude",
    ],
  },
  {
    slug: "lisbon",
    status: "past",
    city: "Lisbon",
    region: "Portugal",
    dateLabel: "APR 12–16",
    category: "Culinary Journey",
    title: "Salt, Smoke & the Atlantic",
    excerpt:
      "Tiled streets, tinned fish and a coastline that seasons everything on the plate.",
    description:
      "From the tiled alleys of Alfama to the Atlantic coast, Eddie follows the salt trail through Portugal's most edible city — and cooks a farewell dinner above the Tagus.",
    storyTitle: "A City Seasoned by the Sea",
    story:
      "Lisbon cooks with the ocean. Everything here carries a memory of salt — the cod, the sardines, the wine, even the light. Eddie spent five days learning how a coastline can season an entire culture.",
    image:
      "https://readdy.ai/api/search-image?query=Lisbon%20hillside%20terracotta%20rooftops%20at%20sunset%20with%20a%20glowing%20river%20below%2C%20cinematic%20editorial%20travel%20photography%2C%20warm%20muted%20palette%2C%2035mm%20film%20grain%2C%20atmospheric&width=1000&height=1250&seq=journey-lisbon-rooftops&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=tinned%20fish%20shop%20shelves%20in%20a%20narrow%20tiled%20Lisbon%20street%2C%20documentary%20editorial%20photography%2C%20warm%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-lisbon-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=grilled%20sardines%20over%20charcoal%20on%20a%20cobbled%20street%20at%20dusk%2C%20documentary%20editorial%20photography%2C%20warm%20glow%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-lisbon-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=farewell%20dinner%20table%20overlooking%20the%20Tagus%20river%20at%20sunset%2C%20documentary%20editorial%20photography%2C%20warm%20golden%20light%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-lisbon-g3&orientation=landscape",
    ],
    highlights: [
      "A tinned-fish tasting through Alfama",
      "Coastal market haul with local chefs",
      "Charcoal sardine supper on the cobbles",
      "Farewell dinner above the Tagus",
    ],
  },
  {
    slug: "tokyo",
    status: "past",
    city: "Tokyo",
    region: "Japan",
    dateLabel: "MAY 09–14",
    category: "Chef Experience",
    title: "Precision, Patience, Umami",
    excerpt:
      "Six days inside the most disciplined kitchens on earth — and the alleys between them.",
    description:
      "Eddie travels to Tokyo to study knife work, broth and restraint at the source, then disappears into the lantern-lit alleys of Shinjuku for the other half of the story.",
    storyTitle: "The Discipline of Flavour",
    story:
      "In Tokyo, every gesture is deliberate. Eddie arrived to learn technique and left with a lesson about attention — how a great kitchen is really just a hundred small decisions made with care.",
    image:
      "https://readdy.ai/api/search-image?query=Tokyo%20back%20alley%20of%20lantern-lit%20izakaya%20at%20night%20in%20the%20rain%2C%20cinematic%20editorial%20travel%20photography%2C%20warm%20amber%20glow%2C%2035mm%20film%20grain%2C%20shallow%20depth%20of%20field&width=1000&height=1250&seq=journey-tokyo-alley&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=hands%20slicing%20fresh%20fish%20with%20a%20long%20knife%20on%20a%20wooden%20board%2C%20documentary%20editorial%20photography%2C%20warm%20light%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-tokyo-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=steaming%20bowl%20of%20broth%20on%20a%20counter%20at%20a%20tiny%20ramen%20shop%2C%20documentary%20editorial%20photography%2C%20warm%20tone%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-tokyo-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=early%20morning%20fish%20market%20with%20vendors%20and%20warm%20light%2C%20documentary%20editorial%20photography%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-tokyo-g3&orientation=landscape",
    ],
    highlights: [
      "Knife-work sessions with Japanese masters",
      "A dawn visit to the fish market",
      "Broth and umami tasting menu",
      "A night through the izakaya alleys",
    ],
  },
  {
    slug: "charleston",
    status: "past",
    city: "Charleston",
    region: "South Carolina, USA",
    dateLabel: "JUN 06–09",
    category: "Locavore Journey",
    title: "Low Country, Deep Roots",
    excerpt:
      "Marsh air, Gullah kitchens and a food culture older than the country itself.",
    description:
      "A journey into the Low Country — shrimp boats at dawn, heirloom rice fields and a long table set between the marsh grass, where Eddie cooks with the keepers of a centuries-old cuisine.",
    storyTitle: "The Oldest Food Story in the South",
    story:
      "Charleston cooks from memory. The flavours here — rice, shellfish, spice — carry generations. Eddie came to listen, and left with a deeper understanding of what it means to cook from a place.",
    image:
      "https://readdy.ai/api/search-image?query=Southern%20low%20country%20farm%20field%20at%20dawn%20with%20marsh%20grass%20and%20mist%2C%20cinematic%20editorial%20travel%20photography%2C%20warm%20earthy%20palette%2C%2035mm%20film%20grain%2C%20soft%20light&width=1000&height=1250&seq=journey-charleston-marsh&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=shrimp%20boat%20at%20dawn%20on%20a%20calm%20marsh%20waterway%2C%20documentary%20editorial%20photography%2C%20warm%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-charleston-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=heirloom%20rice%20field%20at%20golden%20hour%20in%20the%20low%20country%2C%20documentary%20editorial%20photography%2C%20warm%20earthy%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-charleston-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=long%20shared%20table%20set%20in%20a%20marsh%20field%20at%20sunset%2C%20documentary%20editorial%20photography%2C%20warm%20light%2C%20muted%20palette%2C%2035mm%20film%20grain&width=1200&height=800&seq=journey-charleston-g3&orientation=landscape",
    ],
    highlights: [
      "Sunrise with the shrimp fleet",
      "Heirloom rice and Gullah cooking class",
      "A marsh-side long table dinner",
      "Storytelling with the keepers of the cuisine",
    ],
  },
];